module.exports = __webpack_public_path__ + "img/ko_iki4.ad781b34.jpg";